









































































































/* eslint-disable @typescript-eslint/no-explicit-any */
import Vue from 'vue';
import LabelsetSelectView from '../components/LabelsetView/LabelsetSelectView.vue';
import ExplorerHeader from '../components/ExplorerView/ExplorerHeader.vue';
import LabelsetCreateView from '../components/LabelsetView/LabelsetCreateView.vue';
import LabelsetFilenameExtractView from '../components/LabelsetView/LabelsetFilenameExtractView.vue';
import LabelsetFilenameSchemaView from '../components/LabelsetView/LabelsetFilenameSchemaView.vue';
import LabelsetDirectoryExtractView from '../components/LabelsetView/LabelsetDirectoryExtractView.vue';
import LabelsetCSVExtractView from '../components/LabelsetView/LabelsetCSVExtractView.vue';
import LabelsetMultiJsonExtractView from '../components/LabelsetView/LabelsetMultiJsonExtractView.vue';
import LabelsetJsonSchemaView from '../components/LabelsetView/LabelsetJsonSchemaView.vue';
import LabelsetSingleJsonRootSelectionView from '../components/LabelsetView/LabelsetSingleJsonRootSelectionView.vue';
import Modal from '../components/common/Modal/Modal.vue';
import Button from '../components/common/Button/Button.vue';

import { parseObject } from '../utils/parseObject';
import { axiosApiInstance } from '../utils/axiosInstances';
import { Tree } from '../utils/Tree';
import { AnalysisStatusI } from '@/interfaces/AnalysisStatusI';
import { getLabelsetStructure } from '@/utils/axiosAgentInstance';
import { NetworkError } from '@/interfaces/NetworkError';
import { showUnsupportedMessage } from '@/utils/demoUtils';

interface parsedObjectInfoI {
  name: string;
  type: string;
  example: string;
  depth: number;
}

export default Vue.extend({
  props: ['datasetId', 'datasetName'],
  components: {
    LabelsetSelectView,
    ExplorerHeader,
    Modal,
    LabelsetCreateView,
    LabelsetFilenameExtractView,
    LabelsetFilenameSchemaView,
    LabelsetDirectoryExtractView,
    LabelsetCSVExtractView,
    LabelsetMultiJsonExtractView,
    LabelsetJsonSchemaView,
    LabelsetSingleJsonRootSelectionView,
    Button,
  },
  data(): {
    isLabelsetCreateVisible: boolean;
    getResult: boolean;
    pageNumberListIdx: number;
    pageNumberList: number[];
    exampleData: string[];
    result: any;
    directoryStructure?: any;
    fileNameExample?: string;
    csvStructure?: { columns: string[]; values: string[] };
    labelTree?: Tree;
    parsedObject?: parsedObjectInfoI[];
    parsedParentName?: string;
    arrayLeafData?: {
      nodeIdxList: number[];
      parsedObject: parsedObjectInfoI[];
    };
  } {
    return {
      isLabelsetCreateVisible: false,
      getResult: false,
      pageNumberListIdx: 0,
      pageNumberList: [0],
      result: {},
      exampleData: [],
    };
  },
  methods: {
    onClickCreateButton() {
      showUnsupportedMessage(this.$toast);

      // this.isLabelsetCreateVisible = true;
    },
    onClickNextButton() {
      this.getResult = true;
    },
    // NOTE, TBD: 함수 길이가 너무 길어서 분리 필요.
    async onPushResult(payload: any) {
      this.$store.commit('startLoading');
      this.getResult = false;
      let postLabelsetData = false;

      // payload에 ok 플래그가 있어야 로직 실행
      if (!payload.ok) {
        this.$store.commit('stopLoading');
        return;
      }

      // payload의 result를 파싱하는 로직
      // #region labelsetCreate
      if (this.pageNumberList[this.pageNumberListIdx] === 0) {
        this.result = {
          ...this.result,
          name: payload.labelsetName,
          description: payload.labelsetDescription,
          analysis_status: {
            status: 'ERROR',
          } as AnalysisStatusI,
          parsing_rule: {
            target_path: '',
            ignore_list: payload.ignoreList.split(','),
          },
        };

        // 라벨셋 구조 파싱 요청
        try {
          const ignoreList = payload.ignoreList;
          // #region 디렉토리 기반
          if (payload.visitDirectorySection) {
            this.result.parsing_rule.label_type = 'directory';
            const targetPath = await axiosApiInstance
              .get(`/api/v1/datasets/${this.$route.params.datasetId}`)
              .then((result: any) => {
                this.result.parsing_rule.target_path = result.data.result
                  ?.target_path as string;
                return this.result.parsing_rule.target_path;
              })
              .catch((error) => {
                throw new NetworkError(error, 'RESOURCE');
              });
            this.directoryStructure = await getLabelsetStructure(
              'directory',
              targetPath,
              undefined,
              ignoreList,
            )
              .then((response) => {
                return response.data.result.structure;
              })
              .catch((error) => {
                throw new NetworkError(error, 'AGENT');
              });

            this.pageNumberList = this.pageNumberList.concat([1, 2]);
          }
          // #endregion
          // #region 파일명 기반
          else if (payload.visitFilenameSection) {
            this.result.parsing_rule.label_type = 'filename';
            const targetPath = await axiosApiInstance
              .get(`/api/v1/datasets/${this.$route.params.datasetId}`)
              .then((result: any) => {
                this.result.parsing_rule.target_path = result.data.result
                  ?.target_path as string;
                return this.result.parsing_rule.target_path;
              })
              .catch((error) => {
                throw new NetworkError(error, 'RESOURCE');
              });
            this.fileNameExample = await getLabelsetStructure(
              'filename',
              targetPath,
              undefined,
              ignoreList,
            )
              .then((response) => {
                return response.data.result.structure;
              })
              .catch((error) => {
                throw new NetworkError(error, 'AGENT');
              });
            this.pageNumberList = this.pageNumberList.concat([3, 4]);
          }
          // #endregion
          // #region CSV 라벨링
          else if (payload.visitCSVSection) {
            this.result.parsing_rule.label_type = 'csv';

            const csvPathArray: string[] = payload.csvPath.split('\\');
            this.result.parsing_rule.source_file = csvPathArray.pop();
            this.result.parsing_rule.target_path = csvPathArray.join('\\');

            this.csvStructure = await getLabelsetStructure(
              'csv',
              this.result.parsing_rule.target_path,
              this.result.parsing_rule.source_file,
              ignoreList,
            )
              .then((response) => {
                return response.data.result.structure;
              })
              .catch((error) => {
                throw new NetworkError(error, 'AGENT');
              });

            this.pageNumberList = this.pageNumberList.concat([5, 6]);
          }
          // #endregion
          // #region JSON 라벨링
          else {
            if (payload.visitMultipleJSONSection) {
              // 1 : 1 라벨링
              this.result.parsing_rule.label_type = 'multijson';
              this.result.parsing_rule.target_path = payload.labelsetPath;
            } else {
              // N : M 라벨링
              this.result.parsing_rule.label_type = 'singlejson';

              const parsedLabelsetPath: string[] =
                payload.labelsetPath.split('\\');
              const lastElementOfParsedLabelsetPath: string =
                parsedLabelsetPath[parsedLabelsetPath.length - 1];
              if (
                lastElementOfParsedLabelsetPath.substr(
                  lastElementOfParsedLabelsetPath.length - 5,
                ) === '.json'
              ) {
                this.result.parsing_rule.source_file = parsedLabelsetPath.pop();
                this.result.parsing_rule.target_path =
                  parsedLabelsetPath.join('\\');
              } else {
                this.result.parsing_rule.target_path =
                  parsedLabelsetPath.join('\\');
              }
            }

            const structureRequest: {
              labelType: string;
              targetPath: string;
              sourceFile?: string;
            } = {
              labelType: this.result.parsing_rule.label_type,
              targetPath: this.result.parsing_rule.target_path,
            };
            if (this.result.parsing_rule.source_file !== undefined) {
              structureRequest.sourceFile =
                this.result.parsing_rule.source_file;
            }

            const initialObject = await getLabelsetStructure(
              structureRequest.labelType,
              structureRequest.targetPath,
              structureRequest.sourceFile,
              ignoreList,
            )
              .then((response) => {
                if (response.status === 200) {
                  return response.data.result.structure;
                }
              })
              .catch((error) => {
                throw new NetworkError(error, 'AGENT');
              });

            const labelTree = new Tree();
            parseObject(labelTree, initialObject, 1, false);
            this.labelTree = labelTree;

            if (payload.visitMultipleJSONSection) {
              this.pageNumberList = this.pageNumberList.concat([7, 8]);
              this.parsedObject = this.labelTree
                .getData(0)
                .filter((_, idx: number) => idx !== 0);
            } else {
              this.pageNumberList = this.pageNumberList.concat([9, 10, 11]);
              this.arrayLeafData = this.labelTree.getArrayLeafData();
              this.parsedObject = this.arrayLeafData.parsedObject;
            }
          }
          // #endregion
        } catch (error) {
          if (error instanceof NetworkError) {
            console.error(error);
            if (error.errorType === 'RESOURCE') {
              alert(
                '서버와의 연결이 원활하지 않습니다. 잠시 후 다시 시도해주세요.',
              );
            } else if (error.errorType === 'AGENT') {
              console.log(this.$store.getters.isAgentAlive);
              // alert('에이전트 프로그램에 연결할 수 없습니다.');
            }
          } else {
            alert('예기치못한 에러가 발생했습니다.');
          }
          this.$store.commit('stopLoading');
          return;
        }
      }
      // #endregion labelsetCreate

      // #region parsingRule
      else if (
        // 파싱 규칙 설정에서 온 결과를 저장
        this.pageNumberList[this.pageNumberListIdx] === 1 ||
        this.pageNumberList[this.pageNumberListIdx] === 3 ||
        this.pageNumberList[this.pageNumberListIdx] === 5 ||
        this.pageNumberList[this.pageNumberListIdx] === 7 ||
        this.pageNumberList[this.pageNumberListIdx] === 10
      ) {
        this.result = {
          ...this.result,
          parsing_rule: {
            ...this.result['parsing_rule'],
            ...payload.parsing_rule,
          },
        };

        if (this.pageNumberList[this.pageNumberListIdx] === 10) {
          this.result.parsing_rule.properties = [
            this.parsedParentName,
            [payload.parsing_rule.properties],
          ];
        }

        this.exampleData = payload.exampleData;
      }
      // #endregion
      // #region labelScheme
      else if (
        this.pageNumberList[this.pageNumberListIdx] === 2 ||
        this.pageNumberList[this.pageNumberListIdx] === 4 ||
        this.pageNumberList[this.pageNumberListIdx] === 6
      ) {
        this.result = {
          ...this.result,
          label_schema: payload.labelSchema,
          parsing_rule: {
            ...this.result['parsing_rule'],
            properties: payload.properties,
          },
        };

        postLabelsetData = true;
      } else if (
        this.pageNumberList[this.pageNumberListIdx] === 8 ||
        this.pageNumberList[this.pageNumberListIdx] === 11
      ) {
        this.result = {
          ...this.result,
          label_schema: payload.labelSchema,
          parsing_rule: {
            ...this.result['parsing_rule'],
          },
        };

        postLabelsetData = true;
      } else if (this.pageNumberList[this.pageNumberListIdx] === 9) {
        const rootDirectoryIdx =
          this.arrayLeafData?.nodeIdxList[payload.rootDirectory];

        this.parsedObject = this.labelTree
          ?.getData(rootDirectoryIdx)
          .filter((_, idx: number) => idx > 1);
        this.parsedParentName = this.labelTree?.getParentName(rootDirectoryIdx);
      }
      // #endregion

      if (!postLabelsetData) {
        // 라벨셋 등록 하지 않고 다음단계로
        this.pageNumberListIdx += 1;
      } else {
        // 라벨셋 등록

        try {
          const backendResponse = await axiosApiInstance.post(
            `/api/v1/datasets/${this.$route.params.datasetId}/labelsets`,
            this.result,
          );

          if (backendResponse.status === 201) {
            const createdLabelsetId = backendResponse.data.result.labelset_id;

            try {
              // TBD : PREPARED 상태 추가하기 (등록과 동시에 분석을 시작하지 말기)
              // await requestLabelsetAnalysis(createdLabelsetId);
              alert('성공적으로 라벨셋이 등록되었습니다.');
            } catch (analysisError) {
              /** 분석 agent 생성 중 에러 발생 */
              console.error(analysisError);
              alert(
                '라벨셋 생성에 성공하였으나 분석 에이전트 생성에 실패했습니다.',
              );

              await axiosApiInstance.patch(
                `/api/v1/labelsets/${createdLabelsetId}`,
                {
                  analysis_status: {
                    status: 'ERROR',
                    error_code: 'UNDEFINED',
                    error_message: (analysisError as Error).message,
                  },
                },
              );
            }

            this.$emit('closeModal');
          } else {
            console.error(backendResponse.status, backendResponse.statusText);
            alert('라벨셋 등록에 실패했습니다. 다시 시도해주세요.');
          }
        } catch (error) {
          console.error(error);
          alert('라벨셋 등록에 실패했습니다. 다시 시도해주세요.');
        }
      }

      this.$store.commit('stopLoading');
    },
  },
});
